module.exports = __webpack_public_path__ + "img/32-BS5.7a243e8.png";